import { render, staticRenderFns } from "./DocumentChecklistTemplateEditor.vue?vue&type=template&id=5e21d07f"
import script from "./DocumentChecklistTemplateEditor.vue?vue&type=script&lang=js"
export * from "./DocumentChecklistTemplateEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports